//
// Bootstrap: Tab focus mixin
// --------------------------------------------------

/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';
export var tabFocus = function tabFocus() {
  return css(["outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;"]);
};